import { request } from "../_helpers/Auth";

const namespace = "/api/inventories";

export const getInventories = () => {
    return request({
        url: namespace,
        method: "get",
    });
};

export const getInventory = (id) => {
    return request({
        url: `${namespace}/${id}`,
        method: "get",
    });
};

export const createInventory = (data) => {
    return request({
        url: namespace,
        method: "post",
        data,
    });
};

export const updateInventory = (id, data) => {
    return request({
        url: `${namespace}/${id}`,
        method: "put",
        data,
    });
};

export const deleteInventory = (id) => {
    return request({
        url: `${namespace}/${id}`,
        method: "delete",
    });
};
